import gql from "graphql-tag";

export const uploadedModelImage = gql`
  mutation uploadedModelImage(
    $input: UploadedModelImageInput!) {
    uploadedModelImage(input: $input) {
      project {
        id
        updatedAt
        models {
          id
          name
          status
          trialEnds
          cpu
          ram
        }
      }
    }
  }
`;

export const uploadedModelImageOptions = {
  name: "uploadedModelImage",
};
